// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2K4tS","list":"BalanceDue_list__3ajqT","listRow":"BalanceDue_listRow__1DpKy","total":"BalanceDue_total__3zZuT"};